module.exports = __webpack_public_path__ + "media/bootstrap-icons/alarm-fill-24e6a97b.svg";